import React from 'react';
import { Package, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const PackMaintenanceSection = () => {
  return (
    <section id="pack-maintenance" className="py-20 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Texte intro */}
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
              Entretenez vos quais, préservez votre activité
            </h2>
            <p className="text-lg text-slate-600 max-w-4xl mx-auto">
              Niveleurs de quai, portes sectionnelles, rideaux métalliques et équipements périphériques : 
              ORION INDUSTRIE vous accompagne dans l'entretien, la réparation et la remise en état de vos installations.
            </p>
          </div>

          {/* Carte Pack Maintenance */}
          <div className="bg-gradient-to-br from-[#FF6600] to-[#E65A00] rounded-2xl p-8 lg:p-12 text-white shadow-2xl">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full mb-6">
                  <Package className="w-5 h-5" />
                  <span className="font-semibold text-sm uppercase">Offre Prioritaire</span>
                </div>
                <h3 className="text-3xl sm:text-4xl font-bold mb-4">
                  Pack Maintenance Quai
                </h3>
                <p className="text-xl text-orange-100 mb-6">
                  Un seul interlocuteur pour l'entretien de votre porte industrielle et de votre niveleur de quai
                </p>
                <p className="text-orange-100 mb-8">
                  Simplifiez votre maintenance avec une solution complète qui regroupe l'entretien 
                  du niveleur et de la porte sectionnelle ou du rideau métallique associé. Interventions 
                  coordonnées, déplacements mutualisés et suivi centralisé.
                </p>
                <Link to="/maintenance-quai#pack-maintenance">
                  <Button 
                    size="lg"
                    className="bg-white text-[#FF6600] hover:bg-gray-100"
                  >
                    Découvrir nos offres de maintenance
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 border-2 border-white/30">
                <h4 className="text-2xl font-bold mb-6">Ce qui est inclus</h4>
                <ul className="space-y-4">
                  {[
                    { title: 'Révision du niveleur', desc: 'Inspection, graissage, contrôles hydrauliques' },
                    { title: 'Entretien de la porte', desc: 'Maintenance porte sectionnelle ou rideau' },
                    { title: 'Rapport d\'intervention', desc: 'Document détaillé avec recommandations' },
                    { title: 'Contrats disponibles', desc: 'Possibilité de mensualisation du budget' }
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-white rounded-full mt-2 flex-shrink-0"></div>
                      <div>
                        <p className="font-semibold">{item.title}</p>
                        <p className="text-sm text-orange-100">{item.desc}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackMaintenanceSection;
